import React from 'react';
import './App.css';
import { Route, Switch, BrowserRouter } from 'react-router-dom';
import Login from './component/login';
import Home from './component/home';
import Popup from './component/popup';
import BmiCalculator from './component/bmiCalculator';
import Zumba from './component/zumba';
import List from './component/list';
import VideoPage from './component/VideoPage';
import VideoPlayer from './component/VideoPlayer';
import About from './component/about';
import Faq from './component/faq';
import MyList from './component/myList'

class App extends React.Component {

  render() {
    return (
      <div className="App">
        {
          <BrowserRouter>
            <Switch>
              <Route path="/healthportal" exact component={Login}></Route>
              <Route path="/healthportal/home" component={Home}></Route>
              <Route path="/healthportal/about" component={About}></Route>
              <Route path="/healthportal/mylist" component={MyList}></Route>
              <Route path="/healthportal/faq" component={Faq}></Route>
              <Route path="/healthportal/subcat" component={Zumba}></Route> 
              <Route path="/healthportal/videos" component={List}></Route> 
              <Route path="/healthportal/popup" component={Popup}></Route> 
              <Route path="/healthportal/BmiCalculator" component={BmiCalculator}></Route> 
              <Route path="/healthportal/videoplay" component={VideoPage}></Route>
              <Route path="/healthportal/videoplayer" component={VideoPlayer}></Route>
            </Switch>
          </BrowserRouter>
        }
      </div>
    );
  }
}

export default App;